import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import FilesAndDirectoriesService, { Type } from '../../../services/FilesAndDirectoriesService'

type DeleteItemPayload = {
  organization: string
  project: string
  name: string
  type: Type
}
export const useDeleteItem = (directoryPath?: string) => {
  const { org, project } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, DeleteItemPayload>({
    mutationKey: ['delete-project-item'],
    mutationFn: ({ organization, project, name, type }) =>
      FilesAndDirectoriesService.delete(
        organization,
        `${project}/${directoryPath ? `${directoryPath}/` : ''}${name}`,
        type,
      ),
    onSuccess: () => {
      directoryPath
        ? queryClient.invalidateQueries({ queryKey: ['directory-content', org, project, directoryPath] })
        : queryClient.invalidateQueries({ queryKey: ['project-content', org, project] })
    },
  })
}
